import type { Vendor } from '../vendors'

interface VendorCardProps {
	vendor: Vendor
}

const VendorCard = ({ vendor }: VendorCardProps) => (
	<article className="flex flex-col rounded-2xl border border-gray-200 bg-white p-3.5 shadow-sm">
		{/* Contain, not cover: vendor images vary in shape and a crop can cut off the
		    product. Empty alt with a logo, which already names the vendor. */}
		<img
			src={vendor.image}
			alt={vendor.logo ? '' : vendor.name}
			className="aspect-[4/3] w-full rounded-xl object-contain"
		/>

		<h3 className="mt-3 text-lg font-bold leading-snug text-gray-900">
			{vendor.logo ? <img src={vendor.logo} alt={vendor.name} className="h-7 w-auto" /> : vendor.headline}
		</h3>
		<p className="mb-4 mt-1.5 text-base leading-snug text-gray-600">
			{vendor.tagline.map(line => (
				<span key={line} className="block">
					{line}
				</span>
			))}
		</p>

		<a
			href={vendor.demoUrl}
			target="_blank"
			rel="noreferrer"
			className="mt-auto block w-full rounded-xl px-4 py-2.5 text-center text-sm font-semibold text-white no-underline transition-opacity hover:text-white hover:opacity-90"
			style={{ backgroundColor: vendor.brandColor }}
		>
			{vendor.demoLabel}
		</a>
	</article>
)

export default VendorCard
